import React, { Component } from 'react';
import { Button, Input, InputGroup } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

class BufferedInput extends Component {
  static defaultProps = {
    isClearable: true
  };

  constructor(props) {
    super(props);
    this.state = {
      value: this.getValue() || ''
    };
  }

  render() {
    const { groupClassName, isClearable, showSubmit } = this.props;
    const groupItems = !!isClearable || !!showSubmit;

    return groupItems ? (
      <InputGroup className={groupClassName}>
        {this.renderInput()}
        {this.renderButtons()}
      </InputGroup>
    ) : (
      this.renderInput()
    );
  }

  renderInput() {
    const { input, meta, isClearable, showSubmit, submitClassName, ...props } =
      this.props;
    const { value } = this.state;

    return (
      <Input
        {...props}
        {...input}
        value={value}
        onChange={e => {
          this.setState({
            value: e.target.value
          });
        }}
        onKeyDown={e => {
          if (e.keyCode === 13 && !e.shiftKey) {
            this.onChange(this.state.value);
          }
        }}
      />
    );
  }

  renderButtons() {
    const { isClearable, input, showSubmit, submitClassName } = this.props;
    const { value } = this.state;

    return (
      <React.Fragment>
        {isClearable && !!value && (
          <Button
            color="white"
            style={{ borderLeft: 0 }}
            onClick={() =>
              input && input.onChange ? input.onChange('') : this.onChange('')
            }
            title="Clear Value"
          >
            <FontAwesome name="times-circle" fixedWidth />
          </Button>
        )}
        {showSubmit && (
          <Button color="dark-blue" type="submit" className={submitClassName}>
            GO
          </Button>
        )}
      </React.Fragment>
    );
  }

  componentWillReceiveProps(nextProps) {
    const oldValue = this.getValue();
    const newValue = this.getValue(nextProps);

    if (oldValue !== newValue) {
      this.setState({
        value: newValue
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let value = this.getValue();
    if (prevState.value !== this.state.value && this.state.value !== value) {
      clearTimeout(this.changeTimeout);
      setTimeout(() => {
        let value = this.getValue();
        if (value !== this.state.value) {
          this.onChange(this.state.value);
        }
      }, 500);
    }
  }

  getValue(props) {
    props = props || this.props;
    return props.input ? props.input.value : props.value;
  }

  onChange(value) {
    if (this.props.input && this.props.input.onChange) {
      this.props.input.onChange(value);
    } else if (this.props.onChange) {
      this.props.onChange(value);
    }
  }
}

export default BufferedInput;



// WEBPACK FOOTER //
// ./src/components/form/field/buffered-input.js